// extracted by mini-css-extract-plugin
module.exports =  {"title":"pDBKmmI6l9RblvMhpXY6"};